import { Component, OnInit } from '@angular/core';
import { EventStore } from '../service/event.store';

@Component({
  selector: 'pioneer-invoice-history-user',
  templateUrl: './invoice-history-user.component.html'
})
export class InvoiceHistoryUserComponent implements OnInit {

  constructor(
    private eventStore: EventStore) { }

  ngOnInit() {
    this.eventStore.resetSelectedEvent();
  }

}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/invoice-history-user/invoice-history-user.component.ts